module.exports = __webpack_public_path__ + "static/media/check.3a5afd73.svg";